import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=f34c9454&scoped=true&"
import script from "./AppLayout.vue?vue&type=script&lang=js&"
export * from "./AppLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppLayout.vue?vue&type=style&index=0&id=f34c9454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_babel-core@7.0.0-bridge.0_@babel+core@7.12.10__css-loader@5.0.1_webpa_2f9c74bd8b0234781e6cf928f27b0315/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34c9454",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f34c9454')) {
      api.createRecord('f34c9454', component.options)
    } else {
      api.reload('f34c9454', component.options)
    }
    module.hot.accept("./AppLayout.vue?vue&type=template&id=f34c9454&scoped=true&", function () {
      api.rerender('f34c9454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/layouts/AppLayout.vue"
export default component.exports